import { Controller } from 'stimulus'

import { haptics } from '~/common/helpers/haptics'
import { openEmblemPicker } from '~/lib/emblem/picker_api'

import { celebrateReaction } from './reaction_celebration.js'

// The "More emoji" button in the add-reaction popover opens the page's shared
// emoji picker and reacts with whatever the member picks. The server stores a
// named reaction's emoji (❤️) as that reaction, and any other emoji as itself.
export default class extends Controller {
  static targets = ['picker']
  static values = { url: String }

  // The shared picker renders inside whichever button came first. Move it to
  // <body> so removing that post or message (or morphing its reactions) can't
  // take it away; a copy that a later response renders is dropped.
  pickerTargetConnected(picker) {
    if (document.body.querySelector(':scope > .js-reaction-emoji-picker'))
      picker.remove()
    else document.body.append(picker)
  }

  pickAny() {
    // The popover hides on the click, so anchor the picker to the + button.
    const anchor =
      this.element.querySelector('.js-add-reaction-button') || this.element
    openEmblemPicker(anchor, (emoji) => this.react(emoji, anchor))
  }

  react(emoji, anchor) {
    const url = new URL(this.urlValue, window.location.href)
    url.searchParams.set('reaction', emoji)

    const rect = anchor.getBoundingClientRect()
    celebrateReaction({
      key: emoji,
      icon: emoji,
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    })
    haptics.tap()
    $.sajax({ url: url.toString(), type: 'POST', dataType: 'json' })
  }
}
